import { render, staticRenderFns } from "./setting_stream.vue?vue&type=template&id=2cd3296c"
import script from "./setting_stream.vue?vue&type=script&lang=js"
export * from "./setting_stream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports